import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap"
import SButton from "components/Common/Button"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import SeasonAction from "store/season-resource/actions"
import RtwInventoryAction from "store/rtw-inventory/actions"
import Select from "react-select"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"

export default function RtwInventoryManagement() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [pagination, setPagination] = useState({ page: 0, size: 10 })
  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
  })
  const [filter, setFilter] = useState({
    number: "",
    supplierName: "",
    year: "",
    seasonId: "",
    seasonName: "",
  })

  const columns = React.useMemo(
    () => [
      {
        Header: "商品番号",
        accessor: "number",
        defaultCanSort: false,
      },
      {
        Header: "商品名",
        accessor: "productName",
        defaultCanSort: false,
      },
      {
        Header: "お取引先",
        accessor: "supplierName",
        defaultCanSort: false,
      },
      {
        Header: "年度",
        accessor: "year",
        defaultCanSort: false,
      },
      {
        Header: "シーズン",
        accessor: "seasonCode",
        defaultCanSort: false,
      },
      {
        Header: "サイズ",
        accessor: "size",
        defaultCanSort: false,
      },
      {
        Header: "受注数",
        accessor: "numberOfOrders",
        defaultCanSort: false,
      },
      {
        Header: "現在製作中",
        accessor: "currentlyInProduction",
        defaultCanSort: false,
      },
      {
        Header: "実在庫数",
        accessor: "actualInventory",
        defaultCanSort: false,
      },
      {
        Header: "理論在庫",
        accessor: "theoreticalStock",
        defaultCanSort: false,
        Cell: ({ cell }) => (
          <span>
            {cell.row.original.actualInventory <
              cell.row.original.numberOfOrders && "▲"}{" "}
            {cell.row.original.theoreticalStock}
          </span>
        ),
      },
      {
        Header: "",
        accessor: "name",
        defaultCanSort: false,
        Cell: ({ cell }) => (
          <Button
            className="btn-sm button"
            onClick={() =>
              history.push(
                `/inventory-control/rtw-inventory-management/${cell.row.original.productId}/${cell.row.original.size}`
              )
            }
          >
            詳細
          </Button>
        ),
      },
    ],
    []
  )

  React.useEffect(() => {
    dispatch(RtwInventoryAction.getListPage({ ...params, ...pagination }))
  }, [params, pagination])

  React.useEffect(() => {
    dispatch(SeasonAction.getList())
  }, [])

  const onChangeFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    setParams({
      ...filter,
      page: 0,
      size: 10,
    })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"RTW在庫管理"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={3}>
                <TextInputWithLabel
                  label={"商品番号"}
                  placeholder={""}
                  value={filter.number}
                  type="text"
                  name="number"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3}>
                <TextInputWithLabel
                  label={"年度"}
                  placeholder={""}
                  value={filter.year}
                  type="text"
                  name="year"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3}>
                <TextInputWithLabel
                  label={"お取引先"}
                  placeholder={""}
                  value={filter.supplierName}
                  type="text"
                  name="supplierName"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={2}>
                <Label>シーズン</Label>
                <Select
                  isLoading={store.seasonPage.list.loading}
                  options={store.seasonPage.list.data.map(i => ({
                    label: i.name,
                    value: i.id,
                  }))}
                  defaultValue={{
                    value: filter.seasonId,
                    label: filter.seasonName,
                  }}
                  value={{ value: filter.seasonId, label: filter.seasonName }}
                  onChange={e => {
                    if (e) {
                      setFilter({
                        ...filter,
                        seasonId: e.value,
                        seasonName: e.label,
                      })
                    } else {
                      setFilter({ ...filter, seasonId: "", seasonName: "" })
                    }
                  }}
                  isClearable
                />
              </Col>
              <Col
                md={1}
                className="d-flex align-content-end flex-wrap justify-content-start"
              >
                <SButton className="button" onClick={() => onSearch()}>
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row className="mt-3">
              <Col>
                {store.rtwInventory.pageData.loading ? (
                  <Skeleton count={5} />
                ) : store.rtwInventory.pageData.data?.content?.length === 0 ? (
                  <h3 className="text-center">No Data to Display</h3>
                ) : (
                  <TableContainer
                    data={store.rtwInventory.pageData.data?.content || []}
                    columns={columns}
                    pagination
                    page={pagination.page}
                    size={pagination.size}
                    count={store.rtwInventory.pageData.data?.totalPages || 1}
                    setParams={setPagination}
                    params={pagination}
                  />
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
